import {
  SET_ADMIN_LOGIN_POPUP_VISIBLE,
  SET_ADMIN_LOGOUT_VISIBLE,
  SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE
} from "../../../actions/actionTypes";

export const setAdminLoginPopupVisible = (adminLoginPopupVisible = false) => ({
  type: SET_ADMIN_LOGIN_POPUP_VISIBLE,
  payload: {adminLoginPopupVisible}
});

export const setAdminLogoutVisible = (adminLogoutVisible = false) => ({
  type: SET_ADMIN_LOGOUT_VISIBLE,
  payload: {adminLogoutVisible}
});

export const setAdminToolSettingsPopupVisible = (adminToolSettingsPopupVisible = false, adminToolSettingsPopupFeature = null) => ({
  type: SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE,
  payload: {adminToolSettingsPopupVisible, adminToolSettingsPopupFeature}
});
